const state = {
	layerShown: false,
  draftBeforeRender: null
}

const getters = {
  layerShown: state => state.layerShown,
  draftBeforeRender: state => state.draftBeforeRender
}

const mutations = {
	layerShown (state, flag) {
    state.layerShown = flag;
  },
  draftBeforeRender (state, data) {
    state.draftBeforeRender = data;
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/draftPreview/controls.js